import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { SearchLandingPageVGDisclaimerModalWithData } from '../components/SearchLandingPageVGDisclaimerModal/SearchLandingPageVGDisclaimerModal';
import { SearchLandingPageBudgetModalWithData } from '../components/SearchLandingPageBudgetModal/SearchLandingPageBudgetModalWithData';
import { SearchLandingPagePropertyConfigModalWithData } from '../components/SearchLandingPagePropertyConfigModal/SearchLandingPagePropertyConfigModalWithData';
import { SearchLandingPageCommuteAndLocationModalWithData } from '../components/SearchLandingPageCommuteAndLocationModal/SearchLandingPageCommuteAndLocationModalWithData';
import { DemographicsDataDisclaimerModal } from '../components/DemographicDataDisclaimerModal/DemographicDataDisclaimerModal';

export type SearchLandingPageModalTypes =
  | 'location'
  | 'propertyConfig'
  | 'budgetModal'
  | 'searchLandingPageVGDisclaimer'
  | 'demographicsDataDisclaimer';

interface RenderModalProps {
  currentModal: SearchLandingPageModalTypes | null;
  onClose: () => void;
}
export const RenderCurrentModal: FunctionComponent<RenderModalProps> = ({
  currentModal,
  onClose,
}) => {
  switch (currentModal) {
    case 'location':
      return <SearchLandingPageCommuteAndLocationModalWithData onClose={onClose} />;
    case 'propertyConfig':
      return <SearchLandingPagePropertyConfigModalWithData onClose={onClose} />;
    case 'budgetModal':
      return <SearchLandingPageBudgetModalWithData onClose={onClose} />;
    case 'searchLandingPageVGDisclaimer':
      return <SearchLandingPageVGDisclaimerModalWithData opened onClose={onClose} />;
    case 'demographicsDataDisclaimer':
      return <DemographicsDataDisclaimerModal opened onClose={onClose} />;
    default:
      return null;
  }
};

interface SearchLandingPageModals {
  currentModal: SearchLandingPageModalTypes | null;
  setCurrentModal: (modalName: SearchLandingPageModalTypes) => void;
  hideModal: () => void;
  Modals: React.ElementType;
}

export const useSearchLandingPageModals = (): SearchLandingPageModals => {
  const [currentModal, setCurrentModal] = useState<SearchLandingPageModalTypes | null>(null);

  return {
    currentModal,
    setCurrentModal,
    hideModal: () => setCurrentModal(null),
    Modals: () =>
      RenderCurrentModal({
        currentModal,
        onClose: () => setCurrentModal(null),
      }),
  };
};
